/**
 * ============================================================================
 * PAYMENT HISTORY PAGE - 100% Ready
 * ============================================================================
 * 
 * Page for viewing payment history
 */

import React from 'react';
import { UserDashboardLayout } from '../components/user';
import PaymentHistoryComponent from '../components/payment/PaymentHistory';

/**
 * Payment History Page
 * @returns {JSX.Element}
 */
const PaymentHistory = () => {
  return (
    <UserDashboardLayout>
      <PaymentHistoryComponent />
    </UserDashboardLayout>
  );
};

export default PaymentHistory;
